import { createContext, useContext, useEffect, useState } from 'react';
import { fetchDomainLanderSystem } from './helpers';

export const useIsSmartNameDomain = (domainName) => {
  const [isSmartName, setIsSmartName] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const fetchSystem = async () => {
      try {
        const system = await fetchDomainLanderSystem(domainName);
        setIsSmartName(system === 'SN');
      } catch (err) {
        setErrorMessage('failed to connect');
      }
    };
    fetchSystem();
  }, [domainName]);

  return [isSmartName, errorMessage];
};

export const domainNameContext = createContext('');
export const useDomainName = () => useContext(domainNameContext);
